import { Component, Input } from '@angular/core';

import { SiteDoctor } from '../site-doctor.service';

@Component({
  selector: 'ws-site-doctor-rows',
  templateUrl: './doctor-rows.component.html'
})
export class SiteDoctorRowsComponent {
  @Input() doctors: SiteDoctor[] = [];

  trackById(_: number, d: SiteDoctor) { return d.id; }
}
